import React from "react";
import Report from "../component/sections/finance/Report";
import Charge from "../component/sections/finance/Charge";
import Verify from "../component/sections/finance/Verify";
import Invoices from "../component/sections/finance/Invoices";
import Pledge from "../component/sections/finance/Pledge";
import middleware from "./middlewares/middleware";
import OfficialInvoice from "../component/sections/finance/OfficialInvoice";
import manageFinanceRoute from "./manage-finance";
import coworkerFinanceRoute from "./coworker-finance";
import GetGift from "../component/sections/finance/GetGift";

const financeRoutes = [
  {
    path: "/finance/report",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <Report />,
        "Report"
      );
    },
    exact: true,
  },
  {
    path: "/finance/charge",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <Charge />,
        "Charge"
      );
    },
    exact: true,
  },
  {
    path: "/finance/payment/verify",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <Verify />,
        "Verify"
      );
    },
    exact: true,
  },
  {
    path: "/finance/invoices",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <Invoices />,
        "Invoices"
      );
    },
    exact: true,
  },
  {
    path: "/finance/official/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <OfficialInvoice />,
        "OfficialInvoice"
      );
    },
    exact: true,
  },
  {
    path: "/finance/pledge",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <Pledge />,
        "Pledge"
      );
    },
    exact: true,
  },
  {
    path: "/finance/get-gift",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <GetGift />,
        "GetGift"
      );
    },
    exact: true,
  },
  ...manageFinanceRoute,
  ...coworkerFinanceRoute,
];

export default financeRoutes;
